
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_24258_114832)"}},[_c('path',{attrs:{"d":"M4.945 20.256H2.446c-.653 0-1.183-.53-1.183-1.183V6.063c0-.653.53-1.182 1.183-1.182h2.5","stroke":"#E6E7E9","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.867 3.38h-3.52c-.78 0-1.413.634-1.413 1.414v15.548c0 .781.633 1.414 1.413 1.414h3.52M23.781 21.997V3.14c0-.947-.767-1.715-1.714-1.715H11.781c-.947 0-1.714.768-1.714 1.715v18.857c0 .947.768 1.714 1.714 1.714h10.286c.947 0 1.714-.767 1.714-1.714z","stroke":"#E6E7E9","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('g',{attrs:{"clip-path":"url(#clip1_24258_114832)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#E6E7E9"}},[_c('path',{attrs:{"d":"M13.938 9.488a3.013 3.013 0 116.026 0 3.013 3.013 0 01-6.026 0zM13.882 14.377a4.946 4.946 0 013.064-1.079c1.102 0 2.175.378 3.065 1.08.89.7 1.55 1.689 1.887 2.822a.428.428 0 01-.054.36.364.364 0 01-.3.165h-9.196a.364.364 0 01-.3-.166.428.428 0 01-.054-.359 5.619 5.619 0 011.888-2.823z"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_24258_114832"}},[_c('path',{attrs:{"fill":"#fff","transform":"rotate(90 11.966 12.534)","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_24258_114832"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(11.32 6.475)","d":"M0 0h11.25v11.25H0z"}})])])])
          )
        }
      }
    